import React, { useMemo } from 'react';

import {
  ReactFlowProvider,
} from "reactflow";

import axios from "axios";

import WorkflowBasicFlow from '../../../workflow/basic_flow';

// ---------- START STAGE SERVICE ----------
const createStageService = (requestParams, formData, callback) => {
  var promise = axios({
    method: 'post',
    url: Routes.laboral_workflow_stages_path({...{...requestParams}, format: 'json', _options: true }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}

const updateStageService = (requestParams, formData, callback) => {
  var promise = axios({
    method: 'patch',
    url: Routes.laboral_workflow_stage_path({...{...requestParams}, format: 'json', _options: true }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}

const destroyStageService = (requestParams, callback) => {
  var promise = axios({
    method: 'delete',
    url: Routes.laboral_workflow_stage_path({...{...requestParams}, format: 'json', _options: true }),
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}

// ---------- END STAGE SERVICE ----------

// ---------- START EDGE SERVICE ----------
const createEdgeService = (requestParams, formData, callback) => {
  var promise = axios({
    method: 'post',
    url: Routes.laboral_workflow_edges_path({...{...requestParams}, format: 'json', _options: true }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}

const updateEdgeService = (requestParams, formData, callback) => {
  var promise = axios({
    method: 'patch',
    url: Routes.laboral_workflow_edge_path({...{...requestParams}, format: 'json', _options: true }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}

const destroyEdgeService = (requestParams, callback) => {
  var promise = axios({
    method: 'delete',
    url: Routes.laboral_workflow_edge_path({...{...requestParams}, format: 'json', _options: true }),
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}
// ---------- END EDGE SERVICE ----------

// ---------- START GROUP SERVICE ----------
const indexGroupService = (requestParams, callback) => {
  var promise = axios({
    method: 'get',
    url: Routes.laboral_workflow_groups_path({...{...requestParams}, format: 'json', _options: true }),
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}
// ---------- START GROUP SERVICE ----------


const LaboralWorkflowBasicForm = props => {

  const {
    currentUser,
    currentCustomer,
    currentEntityType,
    workflowProcess,
    data
  } = props;

  const processDefaultRequestParams = { id: workflowProcess.hashid }
  const stageDefaultRequestParams = { process_id: workflowProcess.hashid }
  const edgeDefaultRequestParams = { process_id: workflowProcess.hashid }
  const groupDefaultRequestParams = { process_id: workflowProcess.hashid }

  const requirementPublicPath = Routes.new_public_laboral_workflow_requirement_path({
    customer_id: currentCustomer.hashid,
    process_id: workflowProcess.hashid
  });

  return(
    <div className="vh-100">
      <ReactFlowProvider>
        <WorkflowBasicFlow
          data={ data }
          workflowProcess={ workflowProcess }
          currentCustomer={ currentCustomer }
          currentEntityType={ currentEntityType }
          configuration={{
            context:'laboral',
            process: {
              defaultRequestParams: processDefaultRequestParams,
              formName: 'workflow_process'
            },
            stage: {
              defaultRequestParams: stageDefaultRequestParams,
              formName: 'workflow_stage',
            },
            edge: {
              defaultRequestParams: edgeDefaultRequestParams,
              formName: 'workflow_edge',
            },
            group: {
              defaultRequestParams: groupDefaultRequestParams,
            },
            entity: {
              label: currentEntityType?.singular_name
            }
          }}
          services={{
            stage: {
              createService: createStageService,
              updateService: updateStageService,
              destroyService: destroyStageService
            },
            edge: {
              createService: createEdgeService,
              updateService: updateEdgeService,
              destroyService: destroyEdgeService
            },
            group: {
              indexService: indexGroupService
            }
          }}
          routes={{
            requirementPublicPath: requirementPublicPath
          }}
        />
      </ReactFlowProvider>
    </div>
  )
}

export default LaboralWorkflowBasicForm;
